import "./App.css";
import { Component, lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Main from "./Component/Main";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import ScrollToTop from "./Component/ScrollToTop";
import { CartProvider } from "./Component/CartContext";

const About = lazy(() => import("./Component/About"));
const Delivery = lazy(() => import("./Component/Delivery"));
const Returns = lazy(() => import("./Component/Returns"));
const Contact = lazy(() => import("./Component/Contact"));
const Shop = lazy(() => import("./Component/Shop"));
const Terms = lazy(() => import("./Component/Terms"));
const Privacy = lazy(() => import("./Component/Privacy"));
const ProductDetail = lazy(() => import("./Component/ProductDetail"));
const CartPage = lazy(() => import("./Component/CartPage"));
const CheckOut = lazy(() => import("./Component/CheckOut"));
const PaySuccess = lazy(() => import("./Component/SuccessPay"));
const Faqs = lazy(() => import("./Component/Faqs"));
const CookiePolicy = lazy(() => import("./Component/CookiePolicy"));

export default class App extends Component {
  state = { hasError: false };
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError)
      return (
        <main id="main" className="empty-state">
          <h1>Something went wrong</h1>
          <p>Please reload the page to return to the collection.</p>
          <button className="button" onClick={() => window.location.reload()}>
            Reload page
          </button>
        </main>
      );
    return (
      <CartProvider>
        <Router
          future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
        >
          <ScrollToTop />
          <Header />
          <Suspense
            fallback={
              <main id="main" className="loading-page" aria-busy="true">
                <div className="loading-bar" />
                <p>Loading…</p>
              </main>
            }
          >
            <Routes>
              <Route path="/about" element={<About />} />
              <Route path="/shipping" element={<Delivery />} />
              <Route path="/" element={<Main />} />
              <Route path="/returns" element={<Returns />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/faqs" element={<Faqs />} />
              <Route path="/cookies" element={<CookiePolicy />} />
              <Route path="/shopDetails/:id" element={<ProductDetail />} />
              <Route path="/cartpage" element={<CartPage />} />
              <Route path="/checkout" element={<CheckOut />} />
              <Route path="/payment" element={<PaySuccess />} />
              <Route path="/paysuccess" element={<PaySuccess />} />
            </Routes>
          </Suspense>
          <Footer />
        </Router>
      </CartProvider>
    );
  }
}
